import { StyledTag } from './styled';

export const Tag = StyledTag;
